<template>
  <footer class="pmp-bottom-bar">
    <div class="pmp-bottom-inner">
      <button
        v-if="showBack"
        type="button"
        class="pmp-btn-back"
        :disabled="loading"
        @click="$emit('back')"
      >
        <i class="bi bi-arrow-left pmp-btn-icon" aria-hidden="true"></i>
        <span class="pmp-btn-text">Atrás</span>
      </button>

      <button
        type="button"
        class="pmp-btn-primary"
        :disabled="loading"
        @click="$emit('next')"
      >
        <span v-if="loading" class="pmp-btn-content">
          <i class="bi bi-arrow-repeat pmp-btn-icon pmp-btn-spin" aria-hidden="true"></i>
          <span class="pmp-btn-text">{{ loadingLabel }}</span>
        </span>

        <span v-else class="pmp-btn-content">
          <i class="bi pmp-btn-icon" :class="nextIcon" aria-hidden="true"></i>
          <span class="pmp-btn-text">{{ nextLabel }}</span>
        </span>
      </button>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  showBack: {
    type: Boolean,
    default: false
  },
  nextLabel: {
    type: String,
    default: 'Siguiente'
  },
  nextIcon: {
    type: String,
    default: 'bi-arrow-right'
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingLabel: {
    type: String,
    default: 'Enviando...'
  }
})

defineEmits(['back', 'next'])
</script>
